<template>
  <b-table
    show-empty
    head-variant="dark"
    empty-text="No Claims available."
    stacked="md"
    bordered
    striped
    small
    sticky-header="200px"
    :busy="isLoading"
    :items="claimsummary"
    :fields="fieldsClaim"
    style="font-size: 12px"
  >
    <template #table-busy>
      <div class="text-center text-primary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template v-slot:cell(SL)="row">
      {{ row.index + 1 }}
    </template>

    <template v-slot:cell(Accounts)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Accounts')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Accounts }}</b-button
      >
    </template>

    <template v-slot:cell(Auditor)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Auditor')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Auditor }}</b-button
      >
    </template>

    <template v-slot:cell(DGM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'DGM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.DGM }}</b-button
      >
    </template>

    <template v-slot:cell(GM)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'GM')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.GM }}</b-button
      >
    </template>

    <template v-slot:cell(MD)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'MD')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.MD }}</b-button
      >
    </template>

    <template v-slot:cell(ToBePaid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'ToBePaid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.ToBePaid }}</b-button
      >
    </template>

    <template v-slot:cell(Paid)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Paid')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Paid }}</b-button
      >
    </template>

    <template v-slot:cell(Rejected)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Rejected')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Rejected }}</b-button
      >
    </template>
    <template v-slot:cell(Applicant)="data">
      <b-button
        size="sm"
        @click.stop="viewClaims(data.item, 'Applicant')"
        class="mr-1 pt-0 pb-0"
        variant="link"
        >{{ data.item.Applicant }}</b-button
      >
    </template>
  </b-table>
</template>
<script>
import apis from "@/apis";
import * as _ from "lodash";
export default {
  props: {
    districtId: {
      type: String,
      default: '00000000-0000-0000-0000-000000000000'
    }
  },
  watch: {
    districtId(newVal) {
      console.log('District changed to:', newVal);
      this.getClaimSummary(this.currentLoanType);
    }
  },
  mounted() {
    this.getClaimSummary('0');
    this.$root.$on('component1', (loanType) => {
      console.log('Loan type changed:', loanType.temploanType);
      this.currentLoanType = loanType.temploanType;
      this.getClaimSummary(loanType.temploanType);
    })
  },
  methods: {
    getClaimSummary(loanType) {
      this.isLoading = true;
      console.log('Getting claim summary for loanType:', loanType, 'districtId:', this.districtId);
      let promise = apis.ReadClaimDashBoard(loanType);

      promise
        .then((response) => {
          if (response.status == 401) {
            this.$store.dispatch("logout");
            this.$router.replace("/");
            return;
          }
          if (response.status == 200) {
            console.log('Claim data received:', response.body);
            let allClaims = response.body;

            // Filter by district for RoleID 2
            if (this.districtId && this.districtId !== '00000000-0000-0000-0000-000000000000') {
              // Show only the specific district row (not TOTAL)
              this.claimsummary = allClaims.filter(claim =>
                claim.DistrictID === this.districtId && claim.DistrictName !== 'TOTAL'
              );
              console.log('Filtered claims for district:', this.claimsummary);
              console.log('Total claims in response:', allClaims.length);
              console.log('Looking for DistrictID:', this.districtId);

              // If no match found, log all district IDs for debugging
              if (this.claimsummary.length === 0) {
                console.log('Available Districts:', allClaims.map(c => ({name: c.DistrictName, id: c.DistrictID})));
              }
            } else {
              this.claimsummary = allClaims;
              console.log('All claims:', this.claimsummary);
            }

            let ttl = _.filter(allClaims, { DistrictName: "TOTAL" });
            if (ttl && ttl.length > 0) {
              this.$emit("ttl", ttl[0].Accounts, ttl[0].DGM, ttl[0].GM, ttl[0].MD);
            }
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.error('Error loading claims:', err);
          this.isLoading = false;
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    viewClaims(item, sts) {
      this.$store.dispatch("setDistrict", item.DistrictID || this.districtId);
      this.$store.dispatch("setStatusOwner", sts);
      this.$store.dispatch("setLoanType", parseInt(this.currentLoanType));
      this.$router.push("/approveclaims");
    },
  },
  data() {
    return {
      claimsummary: [],
      isLoading: true,
      alertText: "",
      showDismissibleAlert: false,
      currentLoanType: '0',
      variant: "success",
      id:1,
      fieldsClaim: [
        { key: "SL", label: "SL" },
        { key: "DistrictName", label: "District Name" },
        { key: "Accounts", label: "DM" },
        { key: "Auditor", label: "RM" },
        { key: "DGM", label: "PM" },
        { key: "GM", label: "GM" },
        { key: "MD", label: "MD" },
        { key: "ToBePaid", label: "To Be Paid" },
        { key: "Paid", label: "Paid" },
        { key: "Rejected", label: "Rejected" },
        { key: "Applicant", label: "Applicant" },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/ClaimsTableDM.vue